module.exports = __webpack_public_path__ + "images/facebook_icon.cdeabd5e.webp";